<template>
  <l-cache :get-data="getPartner" :id="this.$route.query.code || ''" ref="cache">
    <l-layout slot-scope="{data}" :layout="['xs12']">
      <info-card
        :item="data"
        :opts="opts"
        :update-time="$L.time.stringify(data.updateTime)"
        @orgDetails="goOrgDetails"
      >
        <template slot="title-actions">
          <v-btn color="primary" flat @click="goBindUserDetail">跳转登记用户详情</v-btn>
          <v-btn color="primary" flat @click="transformData(data)" :loading="transformLoading">转化</v-btn>
          <v-btn color="primary" flat @click="goEdit(data)">编辑</v-btn>
          <v-btn color="primary" flat @click="$refs.cache.retry()">刷新</v-btn>
        </template>
        <template slot="append">
          <v-layout column>
            <v-flex xs2>
              <v-btn flat color="primary" @click="goOrgDetails">查看单位详情</v-btn>
            </v-flex>
            <l-data-table
              :headers="vehicleHeader"
              :get-data-func="getVehicleList"
              title-text="绑定车辆列表"
              flat
              hide-title-search>
              <template slot="row-action" slot-scope="{item}">
                <td @click.stop class="px-0 mx-0 text-xs-center">
                  <v-btn @click="goRules(item)" icon >
                    <v-icon small>$vuetify.icons.code</v-icon>
                  </v-btn>
                </td>
              </template>
            </l-data-table>
          </v-layout>
          <!--<v-subheader>通行规则</v-subheader>
          <l-pass-rule-list :pass-rules="data.passRules"></l-pass-rule-list>
          <v-subheader>绑定车辆</v-subheader>
          <v-layout>
            <v-flex>
              <v-chip disabled :key="i" v-for="(v,i) in vehicles(data)">
                <v-avatar>
                  <v-icon>$vuetify.icons.car</v-icon>
                </v-avatar>
                <span>{{v}}</span>
              </v-chip>
              <p v-if="vehicles(data).length === 0" class="text-xs-center grey&#45;&#45;text">没有绑定车辆</p>
            </v-flex>
          </v-layout>-->
        </template>
        <template slot="imgs">
          <v-subheader class="px-2 ml-2">车辆登记图片</v-subheader>
          <v-layout class="px-3 pb-3" wrap>
            <v-flex>
              <template v-for="(img,i) in vehicleInfo.imgItems">
                <l-image-view-dialog :key="i" :src="img.src">
                  <v-subheader slot="activator" class="px-0">
                    {{img.label}}
                  </v-subheader>
                  <l-image-placeholder
                    slot="activator"
                    style="float:left;cursor: pointer"
                    :src="img.src"
                    :error="!!img.error"
                    :error-message="img.error"
                    :loading="!!img.loading"
                  ></l-image-placeholder>
                </l-image-view-dialog>
              </template>
              <template v-if="vehicleInfo.imgItems.length === 0">
                <l-image-placeholder></l-image-placeholder>
              </template>
            </v-flex>
          </v-layout>
        </template>
      </info-card>
    </l-layout>
  </l-cache>
</template>

<script>
import InfoCard from '../../../../../components/infoCard'
import LPassRuleList from '../../../../../components/LPassRuleList'
import LImagePlaceholder from '../../../../../ladmin/components/LImage/LImagePlaceholder'
import LImageViewDialog from '../../../../../ladmin/components/LImageDialog/LImageViewDialog'
import {time} from '../../../../../ladmin/utils/time'
export default {
  name: 'PartnerDetails',
  components: {LPassRuleList, InfoCard, LImagePlaceholder, LImageViewDialog},
  data () {
    return {
      opts: [
        {
          key: 'name',
          label: '姓名',
          layout: ['xs12', 'sm4'],
          icon: '$vuetify.icons.person'
        },
        {
          key: 'code',
          label: '账号',
          layout: ['xs12', 'sm4'],
          icon: '$vuetify.icons.loginId'
        },
        // {
        //   key: 'phone',
        //   label: '电话',
        //   layout: ['xs12', 'sm4'],
        //   icon: '$vuetify.icons.phone',
        // },
        {
          key: 'statusName',
          label: '状态',
          layout: ['xs12', 'sm4'],
          icon: 'mdi-pin'
        },
        {
          key: 'statusCode',
          label: '状态代码',
          layout: ['xs12', 'sm4'],
          icon: 'mdi-pin'
        },
        {
          key: 'orgCode',
          label: '单位代码',
          layout: ['xs12', 'sm4'],
          icon: '$vuetify.icons.levelCode'
        },
        {
          key: 'orgName',
          label: '单位名称',
          layout: ['xs12', 'sm12'],
          icon: '$vuetify.icons.group'
        }
      ],
      vehicleInfo: {
        imgItems: [],
      },
      transformLoading: false,
      partner: {},
      vehicleHeader:[
        {text: '车辆号牌', value: 'plateNumber', align: 'left', sortable: false},
        {text: '车主姓名', value: 'name', align: 'left', sortable: false},
        {text: '联系方式', value: 'phone', align: 'left', sortable: false},
        {text: '提交时间', value: 'creationTime', align: 'left', f: (v) => time.stringify(v)},
        {text: '', value: ''}
      ],
    }
  },
  computed: {
    vehicles () {
      return (data) => {
        let s = data.vehicleList
        return s ? s.split(',') : []
      }
    }
  },
  methods: {
    async getPartner (key) {
      let {items} = await this.$store.dispatch('mva/getPartners', {
        pagination: {},
        filterItems: [{value:key}],
        precious: true
      })
      if (!items.length) {
        throw new Error('未找到该合作用户')
      }
      this.dealImg(items[0])
      this.partner = items[0]
      return items[0]
    },
    dealImg (data) {
      // console.log(data)
      this.vehicleInfo.imgItems = []
      let picArray = JSON.parse(data.fileJson).pic
      if (picArray === null || picArray === undefined) {
        return
      }
      if (picArray.length === 0) {
        return
      }
      if (picArray[0].url1 !== '' && typeof picArray[0].url1 !== 'undefined') {
        let driverLicense = {
          label: '驾驶证',
          src: 'https://smaco2.uestc.edu.cn/passApi' + picArray[0].url1
        }
        this.vehicleInfo.imgItems.push(driverLicense)
      }
      if (picArray[1].url2 !== '' && typeof picArray[1].url2 !== 'undefined') {
        let vehicleLicense = {
          label: '行驶证',
          src: 'https://smaco2.uestc.edu.cn/passApi' + picArray[1].url2
        }
        this.vehicleInfo.imgItems.push(vehicleLicense)
      }
      if (picArray[2].url3 !== '' && typeof picArray[2].url3 !== 'undefined') {
        let otherImage = {
          label: '其他证明',
          src: 'https://smaco2.uestc.edu.cn/passApi' + picArray[2].url3
        }
        this.vehicleInfo.imgItems.push(otherImage)
      }
    },
    goEdit (data) {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: 'EditPartner',
          params: {name: data.name},
          query: {code: data.code}
        })
      })
    },
    async transformData (data) {
      let params = {
        'infos': [
          {
            'code': data.code,
            'name': data.name,
            'phone': data.phone
          }
        ]
      }
      this.transformLoading = true
      try {
        let res = await this.$store.dispatch('userAdmin/transformData', params)
        if (res.data.status + '' === '1') {
          this.$L.alert('success', {message: '数据转化成功'})
        }
        else {
          this.$L.alert('error', {message: '转化失败，原因:' + res.data.msg})
        }
      }
      catch (e) {
        console.log(e)
      }
      finally {
        this.transformLoading = false
      }
    },
    goOrgDetails(){
      this.$router.push({
        name: 'OrgDetails',
        query: {id: this.partner.orgCode}
      })
    },
    async goBindUserDetail(){
      let pagination = {
        page:1,
        rowsPerPage:10
      }
      let filter = [
        {key:'loginId',value:this.$route.query.code}
      ]
      try{
        let {items,amount} = await this.$store.dispatch('userAdmin/getUsers',{pagination:pagination,filter:filter})
        if(items.length===0){
          this.$L.alert('error',{message:'该用户未转化为登记用户，请点击右上角转化按钮或者绑定微信公众号进行转化'})
        }else{
          this.$router.push({
            name: 'UserDetails',
            params: {loginId: this.$route.query.code},
            query: {id: items[0].id, from: 'user'}
          })
        }
      }catch (e) {
        console.log(e)
      }
    },
    async getVehicleList ({pagination, sortStack, filterItems, search}) {
      let userRes = await this.$store.dispatch('userAdmin/getUsers',{pagination,search:{key:"loginId",value:this.$route.query.code}})
      if(userRes.items.length===0){
          return {items:[],amount:0}
      }else{
          let filter = [
            {key:"userId",value:userRes.items[0].id}
          ]
          let {items,amount} = await this.$store.dispatch('passControl/getSelfVehicleList', {pagination,filter:filter})
          let arr = []
          for(let i=0;i<items.length;i++){
            let item = items[i]
            item.plateNumber = item.vehicle.plateNumber
            item.name = item.user.name
            item.phone = item.user.mobilePhone
            item.creationTime = item.vehicle.creationTime
            arr.push(item)
          }
          return {items: arr, amount: amount}
        }
    },
    goRules(item){
      this.$router.push({
        name:'vehicleRuleDetailsBox',
        query:{
          id:item.plateNumber
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
